import { useEffect, useState } from 'react';
import type {
  AccountWeddingLocationView,
  SearchLocationView,
} from '@zola/svc-marketplace-ts-types';

import {
  getBriefLocation,
  getSearchedLocation,
  getSearchLocationForBriefLocation,
} from '@zola-helpers/client/dist/es/marketplace/vendorSearchUtils';
import { LocationOrAllMarketsType } from '@zola-helpers/client/dist/es/marketplace/types';
import ApiService from '@zola-helpers/client/dist/es/http/api';

export const useLocationForVendorSRPLink = ({
  isInSRPExperiment,
}: {
  isInSRPExperiment?: boolean;
}) => {
  // the most recently searched location, from cookies
  const searchedLocation = getSearchedLocation();

  // wedding location from account preferences, formatted to be used in a vendor search URL
  const [weddingLocation, setWeddingLocation] = useState<SearchLocationView>();

  // final location to be returned
  const [locationForSearch, setLocationForSearch] = useState<
    LocationOrAllMarketsType | undefined
  >();

  useEffect(() => {
    if (searchedLocation) {
      if (
        searchedLocation.type !== 'ALL_MARKETS' &&
        searchedLocation.slug !== locationForSearch?.slug
      ) {
        setLocationForSearch(searchedLocation);
      } else if (
        searchedLocation.type === 'ALL_MARKETS' &&
        weddingLocation?.slug !== locationForSearch?.slug
      ) {
        setLocationForSearch(weddingLocation);
      }
    }
  }, [searchedLocation, weddingLocation]);

  useEffect(() => {
    // we only want to fetch if we have already checked the most recently searched location and it comes back "empty" aka ALL_MARKETS
    if (
      isInSRPExperiment &&
      searchedLocation &&
      searchedLocation.type === 'ALL_MARKETS' &&
      !weddingLocation
    ) {
      /** Will default to IP address if no wedding location given (works for pre-auth users) */
      ApiService.get<AccountWeddingLocationView>(
        '/web-marketplace-api/v1/account-preferences/location'
      )
        .then((response) => {
          setWeddingLocation(getSearchLocationForBriefLocation(getBriefLocation(response)));
        })
        .catch(() => undefined);
    }
  }, [isInSRPExperiment, searchedLocation, weddingLocation]);

  if (isInSRPExperiment) {
    return locationForSearch;
  }

  return undefined;
};
